export default __webpack_public_path__ + "static/media/HaloLogo.102588d9.svg";